import type { SensitivityType } from "./factor-sensitivity/types"
import type { TemplateChartSettings } from "connected-components/dashboard/store/template-chart-settings"

// Per-template chart-settings keys + defaults. Every graph template defaults selectedCategory to "total".

export const GRAPH_RISK_TEMPLATE_KEY = "risk"
export const GRAPH_PERFORMANCE_TEMPLATE_KEY = "performance"
export const GRAPH_EXPOSURE_TEMPLATE_KEY = "exposure"
export const GRAPH_CONTENT_SET_TEMPLATE_KEY = "content-set"

// Predicted and historical factor sensitivity persisted independently (was two preference subtypes).
export const graphFactorSensitivityTemplateKey = (sensitivityType: SensitivityType): string =>
  `factor-sensitivity-${sensitivityType}`

export const GRAPH_CATEGORY_DEFAULTS: TemplateChartSettings = { selectedCategory: "total" }
